import { rem } from "../../../Theme/Theme.constants.js";

export const variants = {
    hidden: {
        width: 0,
    },
    visible: {
        width: rem(4),
    },
};
